import classnames from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { components } from '@glowforge/ui-common';

import { userPropTypes } from 'app/selectors/user';
import featuresHOC from 'app/common/containers/features';
import { GLOWFORGE_LANDING_PAGE, GLOWFORGE_STORE } from 'app/route-constants';
import NavigationItem from './navigation-item';
import { getNavigationTabs, userRoutes, userSecondaryLinks } from './config';

const { TopNav } = components;

/**
 * Top Navigation for the site.
 * Will render differently for marketing pages, shop/catalog/community, and order page.
 * See ./config for more information.
 *
 * @param {Object}  user Logged in user
 * @param {bool}    hideNavLinks
 */
class Navigation extends Component {
  static propTypes = {
    user: PropTypes.shape(userPropTypes),
    hideNavLinks: PropTypes.bool,
    hideUserSection: PropTypes.bool,
    features: PropTypes.object, // eslint-disable-line
    useMarketingNav: PropTypes.bool,
    includeBuyButton: PropTypes.bool,
    route: PropTypes.shape({
      path: PropTypes.string,
    }),
  };

  static defaultProps = {
    user: undefined,
    hideNavLinks: false,
    hideUserSection: false,
    useMarketingNav: false,
    features: {},
    includeBuyButton: false,
    route: { path: null },
  };

  constructor(props) {
    super(props);
    this.state = {
      belowTheFold: false,
    };

    this.throttledScroll = _.throttle(this.handleScroll, 200);
  }

  componentDidMount() {
    // Only need scroll listener for homepage.
    if (this.props.route.path === GLOWFORGE_LANDING_PAGE.BASE_URI) {
      window.addEventListener('scroll', this.throttledScroll);
    }
  }

  componentWillUnmount() {
    this.removeScrollListener();
  }

  getBuyButton = () => {
    const { includeBuyButton, route } = this.props;
    if (!includeBuyButton) {
      return null;
    }

    const classNames = classnames('buyButton', 'button', 'primary', 'small', {
      // Only hide buyButton if on homepage and not been below the fold.
      hidden: !this.state.belowTheFold && route.path === GLOWFORGE_LANDING_PAGE.BASE_URI,
      // buyButton is inverted colors only on homepage
      inverted: route.path === GLOWFORGE_LANDING_PAGE.BASE_URI,
    });

    return (
      <div className='buyButtonSection'>
        <a
          className={classNames}
          href={GLOWFORGE_STORE.BASE_URI}>
          Shop Now
        </a>
      </div>
    );
  }

  /**
   * Helper to remove scrollListener
   */
  removeScrollListener() {
    this.throttledScroll.cancel();
    window.removeEventListener('scroll', this.throttledScroll);
  }

  /**
   * Keep track of whether the user has scrolled below the fold.
   * Will remove the scroll listener once belowTheFold is true.
   */
  handleScroll = () => {
    const { belowTheFold } = this.state;
    const belowTheFoldHeight = window.innerHeight * 0.8;
    // only set state if it will be different
    if (!belowTheFold && (window.scrollY > belowTheFoldHeight)) {
      this.setState({ belowTheFold: true });
      this.removeScrollListener();
    }
  }

  render() {
    const {
      user,
      isRestricted,
      hideNavLinks,
      hideUserSection,
      useMarketingNav,
      features,
    } = this.props;

    const primaryRoutes = getNavigationTabs(
      features,
      hideNavLinks,
      isRestricted,
      useMarketingNav,
      user,
    );

    const logoLink = useMarketingNav ?
      GLOWFORGE_LANDING_PAGE.BASE_URI : this.props.features.GFCORE_SITE_URL;

    return (
      <TopNav
        marketing={useMarketingNav}
        logoLink={logoLink}
        user={user}
        userRoutes={userRoutes}
        userSecondaryLinks={isRestricted ? null : userSecondaryLinks}
        primaryRoutes={primaryRoutes}
        // eslint-disable-next-line react/jsx-no-bind
        buttonSection={this.getBuyButton()}
        hideNavLinks={hideNavLinks}
        hideUserSection={hideUserSection}
        NavigationItem={NavigationItem} />
    );
  }
}

export default featuresHOC(Navigation);



// WEBPACK FOOTER //
// ./app/common/components/navigation/navigation.jsx